var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pre"},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.rulesText)))])
}
var staticRenderFns = []

export { render, staticRenderFns }